const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Horário letivo',
        },
      },
    },
  },
};

export default layout;
